/* prettier-ignore */

import { Component, computed, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslationService } from 'src/app/services';
import { baseLanguageCode } from 'src/app/services/helpers/language.util';
import { ToolsService } from 'src/app/services/tools.service';
import { SelectGoogleLanguageComponent } from 'src/app/shared/select-google-lang/select-google-lang.component';

@Component({
  selector: 'header-languages',
  templateUrl: './languages.component.html',
  styleUrl: './languages.component.scss',
})

export class HeaderLanguagesComponent {
    private _translationService = inject(TranslationService);

    public isTechMode = computed(() => this.tools.isTechMode())
    public isTechEditMode = computed(() => this.tools.isTechEditMode());
    public isRegisterMode = computed(() => this.tools.isRegisterMode());
    public languages = this._translationService.languages;
    public isWebApp = computed(() => this.tools.isWebApp());
    public headerLangType = this._translationService.headerLangType;
    public showGoogleLangs = this._translationService.showGoogleLangs;
    public displayLanguage = this._translationService.displayLanguage;

    /** Código corto para el selector en modo texto: pt-BR → "pt" (HRS-2934). */
    public shortCode(code: string): string {
      return baseLanguageCode(code) || code;
    }

  constructor(
    private modalCtrl: ModalController,
    private tools: ToolsService
  ) {}

  changeLanguage(lang){
    this._translationService.changeLanguage(lang);
  }

  async changeGoogleLanguage(){
    const modal = await this.modalCtrl.create({
        component: SelectGoogleLanguageComponent,
        cssClass: ['langModal', 'ion-disable-focus-trap'],
    });
    await modal.present();
  }
}
